<template lang="html">
	<form class="form-ui column default-form-ui" novalidate @submit.prevent="onSubmit">
		<div class="ctn-big-block">
			<text-input name="product"
									label="Produit"
									v-model="investmentProduct.product_name" />
		</div>
		<div class="ctn-big-block ctn-big-block row">
			<div class="ctn-duo-input row">
				<div class="left inner-duo">
					<text-input name="subscription_date"
											label="Date de souscription"
											type="date"
											v-model="investmentProduct.subscription_date"
					/>
				</div>
				<div class="right inner-duo">
					<div class="ctn-input ctn-label" v-selectUI :class="{error: errors.has('product_type')}">
						<label for="product_type">Type de produit</label>
						<custom-select :items="productTypes" v-model="investmentProduct.product_type" />
					</div>
					<div v-if="errors.has('product_type')" class="error-message">{{ errors.first('product_type') }}</div>
				</div>
			</div>
		</div>
		<div class="ctn-big-block ctn-big-block row">
			<div class="ctn-duo-input row">
				<div class="left inner-duo">
					<text-input name="contract_number"
											label="Numéro de contrat"
											v-model="investmentProduct.contract_number"
					/>
				</div>
				<div class="right inner-duo">
					<div class="ctn-input ctn-label" v-selectUI :class="{error: errors.has('contract_type')}">
						<label for="contract_type">Type de contrat</label>
						<custom-select :items="contractTypes" v-model="investmentProduct.contract_type" />
					</div>
					<div v-if="errors.has('contract_type')" class="error-message">{{ errors.first('contract_type') }}</div>
				</div>
			</div>
		</div>
		<div class="ctn-big-block row">
			<div class="ctn-duo-input row">
				<div class="left inner-duo">
					<text-input name="shares_number"
											label="Parts"
											v-model="investmentProduct.shares_number" type="number" />
				</div>
				<div class="right inner-duo">
					<div class="inner-row">
						<div class="ctn-input ctn-label ctn-currency" v-inputUI :class="{error: errors.has('shares_number')}">
							<label for="shares_number" :class="{'active': investmentProduct.share_price_currency}">
								Prix de la part
							</label>
							<input
								type="number"
								name="share_price"
								ref="share_price"
								v-model="investmentProduct.share_price"
							>
							<custom-select :items="currencyList"
														 v-model="investmentProduct.share_price_currency" />
						</div>
						<div v-if="errors.has('share_price')" class="error-message">{{ errors.first('share_price') }}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="ctn-big-block row">
			<div class="ctn-duo-input row">
				<div class="left inner-duo">
					<div class="inner-row">
						<div class="ctn-input ctn-label ctn-currency" v-inputUI :class="{error: errors.has('net_income_distributed')}">
							<label for="net_income_distributed" class="active">
								Revenu net distribué
							</label>
							<input
								type="number"
								name="net_income_distributed"
								ref="net_amount_distributed"
								v-model="investmentProduct.net_income_distributed"
							>
							<custom-select :items="currencyList"
														 v-model="investmentProduct.net_income_distributed_currency" />
						</div>
						<div v-if="errors.has('net_income_distributed')" class="error-message">{{ errors.first('net_income_distributed') }}</div>
					</div>
				</div>
				<div class="right inner-duo">
					<div class="inner-row">
						<div class="ctn-input ctn-label ctn-currency" v-inputUI :class="{error: errors.has('subscription_price')}">
							<label for="subscription_price">
								Prix d'achat de la part
							</label>
							<input
								type="number"
								name="subscription_price"
								ref="subscription_price"
								v-model="investmentProduct.subscription_price"
							>
							<custom-select :items="currencyList"
														 v-model="investmentProduct.share_price_currency" />
						</div>
						<div v-if="errors.has('subscription_price')" class="error-message">{{ errors.first('subscription_price') }}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="ctn-big-block row" style="justify-content:left;">
			<div class="left inner-duo" style="width: calc(50% - 0.5rem);">
				<div class="inner-row">
					<div class="ctn-input ctn-label ctn-currency" v-inputUI :class="{error: errors.has('income_since_anniversary')}">
						<label for="income_since_anniversary" class="active">
							Revenus depuis la date d'anniversaire
						</label>
						<input
							type="number"
							name="income_since_anniversary"
							ref="income_since_anniversary"
							v-model="investmentProduct.income_since_anniversary"
						>
						<custom-select :items="currencyList"
													 v-model="investmentProduct.share_price_currency" />
					</div>
					<div v-if="errors.has('income_since_anniversary')" class="error-message">{{ errors.first('income_since_anniversary') }}</div>
				</div>
			</div>
		</div>

		<div class="ctn-cta row start">
			<router-link :to="{name: 'InvestmentsManual', params: {clientId: clientId, kind: isCgpi ? 'cgpi' : 'client'}}" class="ctn-icon">
				<div class="btn btn-gold">Annuler</div>
			</router-link>
			<button type="submit" class="btn btn-red" :class="{'btn-disabled': !isFormValidated || isFormLoading}">
				Enregistrer
			</button>
		</div>
	</form>
</template>

<script>
/* eslint-disable */
import TextInput from '@/common/components/Form/TextInput'
import Currency from '@/common/components/MyPatrimonialLandscape/data/Currency'
import CustomSelect from '@/common/components/Form/CustomSelect'

/* eslint-disable */

export default {
	name: 'EditMain',
	components: {
		TextInput,
		CustomSelect
	},
	props: {
		investmentProduct: {
			type: Object
		},
		clientId: {
			type: Number
		},
		kind: {
			type: String,
			default: 'cgpi'
		}
	},
	data () {
		return {
			submitted: false,
			currencyList: Currency,
			contractTypes: ['Nue propriété', 'Pleine propriété'],
			productTypes: ['Financier', 'Tangible', 'International']
		}
	},
	mounted () {
	},
	methods: {
		onSubmit () {
			this.submitted = true

			if (this.investmentProduct.id && this.investmentProduct.id > 0) {
				this.updateInvestmentProduct()
			} else {
				this.addInvestmentProduct()
			}
		},

		updateInvestmentProduct () {
			this.$store.dispatch('setInvestmentProduct', this.investmentProduct)
			.then((result) => {
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Produit modifié',
					text: 'Le produit a bien été modifié !'
				})

				if (this.isCgpi) {
					this.$router.push({ name: 'InvestmentsManual', params: { id: this.clientId.toString() } })
				}
				else {
					this.$router.push({ name: 'InvestmentsManual', params: { kind: 'client' } })
				}
			})
			.catch((e) => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				})
			})
			.finally(() => {
				this.submitted = false
			})
		},
		addInvestmentProduct () {
			let clientId
			if (!this.isCgpi)
				clientId = this.$store.getters['user'].id
			else
				clientId = this.clientId

			this.$store.dispatch('addInvestmentProduct', {clientId: clientId, investmentProduct: this.investmentProduct})
				.then((result) => {
					this.$notify({
						type: 'success',
						group: 'default',
						title: 'Produit ajouté',
						text: 'Le produit a bien été ajouté !'
					})

					if (this.isCgpi)
						this.$router.push({ name: 'InvestmentsManual', params: { id: clientId } })
					else
						this.$router.push({ name: 'InvestmentsManual', params: { kind: 'client' } })
				})
				.catch((e) => {
					this.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: e.message
					})
				})
				.finally(() => {
					this.submitted = false
				})
		},
	},
	computed: {
		isFormValidated () {
			return true
		},
		isFormLoading () {
			return this.submitted
		},
		isCgpi() {
			return this.kind === 'cgpi'
		}
	},
	watch: {
		'investmentProduct.share_price': function (value) {
			if (value) {
				this.$refs.share_price.focus()
			}
		},
		'investmentProduct.subscription_price': function (value) {
			if (value) {
				this.$refs.subscription_price.focus()
			}
		}
	}
}
</script>

<style lang="css" scoped>
.default-form-ui .ctn-input input[type="date"] {
    padding: 0.5rem 0.8rem !important;
}
</style>



// WEBPACK FOOTER //
// Main.vue?59fc99cb